import { Component, ElementRef, Input, SimpleChange, ViewChild, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { SearchCountryField, CountryISO, NgxIntlTelInputComponent, ChangeData } from 'ngx-intl-tel-input';
import { countries } from './countries-model';

@Component({
  selector: 'input-phone',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss']
})
export class PhoneInputComponent implements OnInit {
  @ViewChild("ng") ng: NgModel;
  @ViewChild("cont") cont: NgxIntlTelInputComponent;
  @Input() isRequired = false;
  @Input() disabled: boolean = false;
  @Input() showMessages: boolean;

  model: ChangeData;
  formGroup: FormGroup;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = countries;

  constructor() {
  }

  ngOnInit(): void {
    this.createForm();
  }
  createForm() {
    this.formGroup = new FormGroup({
      phone: new FormControl(""),
    });
    this.formGroup.statusChanges.subscribe(() => {
      // console.log("test ", result)
    });

    const phone: any | undefined = this.formGroup.get("phone");

    phone.setValidators([
      Validators.required,
      // Validators.pattern(this.phoneRegex),
    ]);

    phone.updateValueAndValidity();
  }

  // formatValue(data: ChangeData | null) {
  //   if (!data && this.inputModel.model) {
  //     return this.inputModel.model;
  //   } else if (data) {
  //     return data.e164Number;
  //   }
  // }

  applyValidationToControl() {
    if (this.ng.control.invalid) {
      this.formGroup.controls['phone'].setErrors(this.ng.control.errors, { emitEvent: true });
    } else {
      this.formGroup.controls['phone'].setErrors(null, { emitEvent: true })
    }
  }

}
